// Basic helper functions for site cookies
import $ from 'jquery';

export const checkCookie = (cookieName) => {
  if (navigator.cookieEnabled) {
    $("#modal-cookie-message").hide();
  } else {
    $("#modal-cookie-message").show();
  }
  let visited = getCookie(cookieName);
  if (visited === "true") {
    $("#modal-disclaimer-window").removeClass("show");
    // deleteCookie(cookieName, "true");  // For testing. Shows disclaimer every other time.
  } else {
    $("#modal-disclaimer-window").addClass("show");
    setCookie(cookieName, "true", 14);
  }
};

function setCookie(cookieName, cookieValue, daysTillExpired) {
  let d = new Date();
  d.setTime(d.getTime() + (daysTillExpired * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  expires = "max-age=" + (daysTillExpired * 86400); // 60*60*24 = 86,400 (seconds in one day) *14 = 1209600
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";SameSite=Strict;path=/";
}

function getCookie(cookieName) {
  let name = cookieName + "=";
  let allCookies = document.cookie.split(';');
  for (let idx = 0; idx < allCookies.length; idx++) {
    let cookie = allCookies[idx];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return "";
}

function deleteCookie(cookieName, cookieValue) {
  // document.cookie = cookieName + "=" + cookieValue + "; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  document.cookie = cookieName + "=" + cookieValue + "; max-age=0; path=/";
}
